export enum DateFormats {
  TICKET_LIST_FORMAT = 'dd.MM.yyyy',
  NOTE_DATE = 'dd/MM/yyyy kk:mm',
  INPUT_DATE = 'yyyy-MM-dd',
  HOUR_MINUTE = 'kk:mm',
}

export const emptyDate = '--/--/----';
